import React, { Component } from 'react';

// Externals
import classNames from 'classnames';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';


import ResponseTimeGeneral from './ResponseTimeGeneral';
import ResponseTimeForStep from './ResponseTimeForStep'
import ResponseTimeForNode from './ResponseTimeForNode'
import Period from '../../../../helpers/Period';

// Material helpers
import { withStyles } from '@material-ui/core/styles';


import { withRouter } from 'react-router-dom';


// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletToolbar from 'components/PortletToolbar';
import PortletContent from 'components/PortletContent';
import PortletFooter from 'components/PortletFooter';
// Custom components
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import RefreshIcon from '@material-ui/icons/Refresh';
import Switch from '@material-ui/core/Switch';
import Tooltip from '@material-ui/core/Tooltip';

// Material components
import IconButton from '@material-ui/core/IconButton';
import InfoIcon from '@material-ui/icons/Info';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import HelpIcon from '@material-ui/icons/Help';
import UpdateIcon from '@material-ui/icons/Update';
import Avatar from '@material-ui/core/Avatar';

import Button from '@material-ui/core/Button';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import QueryBuilderIcon from '@material-ui/icons/QueryBuilder';

import PerfectScrollbar from 'react-perfect-scrollbar';

// Palette
import palette from 'theme/palette';


// Component styles
import styles from './styles';

import moment from 'moment-timezone'
import 'moment/locale/es'
import { getDefaultPeriod } from '../../../../utils/local-storage/select-periodo';
import { useTranslation, withTranslation } from 'react-i18next';
moment.locale('es')


const REFRESH_TIME = 300000

class ResponseTime extends Component {

    constructor(props) {
        super(props);
        var statePeriod={}
        var periodical=false
        var scheduleType=0
        var scheduleName=props.t('text.all-schedules')
        var indexGraph=0
        //console.log('paso', props.step)
        var Indexstep=this.props.location.state.fromObjective.Pasos[0].id_paso
        var nameStep=this.props.location.state.fromObjective.Pasos[0].nombre_paso
        if(props.periodical===true || props.online==true) {
            if(props.typeGraph===1|| props.typeGraph===2){
                Indexstep=parseInt(props.step.id_paso)
                nameStep=props.step.nombre_paso
            }
            var year=String(props.year)
            var month=String(props.indexMonth+1)
            const begin=(moment(year+'-'+month+'-01')._d)
            const final= (moment(begin).endOf('month')._d)
            var schedules=JSON.parse(sessionStorage.getItem("horarios"))
            periodical=true
            statePeriod={startDate: begin,endDate: final,key: "selection"}
            scheduleType=props.schedule
            scheduleName=(schedules.filter(i=>i.horario_id==props.schedule))[0]["nombre"]
            indexGraph=props.typeGraph
        }
        if (props.globalPeriodValue === "custom") {
            statePeriod = props.globalStatePeriod
        }
        if(props.period === 'c' && props.online==true) {
            
            if(props.typeGraph===1|| props.typeGraph===2){
                Indexstep=parseInt(props.step.id_paso)
                nameStep=props.step.nombre_paso
            }
            var date = props.statePeriodResponseTime
            const begin=(moment(date.startDate)._d)
            const final= (moment(date.endDate)._d)
            statePeriod ={startDate: begin,endDate: final,key: "selection"}
            scheduleType=props.schedule
            indexGraph=props.typeGraph
        }
        // console.log(statePeriod)
        
        this.handleResponseClick = this.handleResponseClick.bind(this);
        this.handleStepClick = this.handleStepClick.bind(this);
        this.handleNodeClick = this.handleNodeClick.bind(this);
        this.handlePeriodClick = this.handlePeriodClick.bind(this);
        this.handleNextStepClick = this.handleNextStepClick.bind(this);
        this.handleInfo = this.handleInfo.bind(this);
        this.handleFirstInfo = this.handleFirstInfo.bind(this);
        this.handleDateMoment = this.handleDateMoment.bind(this);
        const t = (this.props && this.props.t) ? this.props.t : (s => s);
        this.state = {
            typeGraph: indexGraph,
            period: this.props.period,
            step: Indexstep,
            isForStep: false,
            nameStep: null,
            namePeriod: null,
            x: null,
            y: null,
            isLastEvent: false,
            objetive: this.props.match.params.objetivo_id,
            statePeriod: statePeriod,
            isStatePeriod: false,
            responseTimeGraphEl: null,
            periodEl: null,
            extendEl: null,
            nameGraph: [' Consolidado', ' Detalle por Paso', ' Detalle por Monitor'],
            typePeriod: this.props.typePeriod,
            //nameSelectStep: "Seleccione Paso"
            nameSelectStep: nameStep,
            settingsEl: null,
            isRefresh: false,
            isInfo: null,
            checkedA: this.props.automaticUpdate,
            date: new Date(),
            periodical:periodical,
            dateMoment: (moment().tz(sessionStorage.getItem('tz')).format("DD/MM/YYYY, HH:mm:ss a")),
            isOneHour: false,
            schedule:scheduleType,
            scheduleName:scheduleName,
            detalleGraph:[' Corresponde a los tiempos de respuestas consolidados (promedio desde todos los ISPs) del objetivo durante el período y horario seleccionado.', 
                        ' Corresponde a la información estadística de los tiempos de respuestas del objetivo, separado por paso, durante el período y horario seleccionado.',
                        ' Corresponde a los tiempos de respuesta del objetivo,para cada ISP desde donde se monitorea el objetivo, separado por paso, durante el período y horario seleccionado.'],
            intervalId: null,
        };
    }

    componentDidMount() {
        if (this.props.automaticUpdate) {
            const newIntervalId = setInterval(
                () => this.tick(),
                this.props.refreshTime || REFRESH_TIME
            );
            this.setState({intervalId: newIntervalId})
        }
        const {appliedToAllSelected, parseSelectedGlobalPeriod} = getDefaultPeriod()
        if (this.props.globalPeriodValue !== undefined && !this.props.periodical && !this.props.online && (appliedToAllSelected && parseSelectedGlobalPeriod)) {
            this.handlePeriodClick(null, this.state.typeGraph, parseSelectedGlobalPeriod.statePeriod, parseSelectedGlobalPeriod.value)
        }
    }

    componentWillUnmount() {
        clearInterval(this.state.intervalId);
    }
    
    tick() {
        if(this.state.checkedA===true){
            this.setState({
            date: new Date(),
            dateMoment:(moment().tz(sessionStorage.getItem('tz')).format("DD/MM/YYYY, HH:mm:ss a")),
            isRefresh: true
            });
        }
    }

    handleResponseClick() {
        const t = this.props.t;
        this.setState({
            typeGraph: 0,
            isForStep: false,
            isLastEvent: false,
            responseTimeGraphEl: null,
            //nameSelectStep: t("response-time.select-step"),
            isRefresh: false,
            isOneHour: false,
        });
    }

    handleStepClick() {
        this.setState({
            typeGraph: 1,
            isForStep: true,
            isLastEvent: false,
            responseTimeGraphEl: null,
            isRefresh: false,
            isOneHour: false,
        });
    }

    handleNodeClick() {
        this.setState({
            typeGraph: 2,
            isForStep: true,
            isLastEvent: false,
            responseTimeGraphEl: null,
            isRefresh: false,
            isOneHour: false,
        });

    }

    handlePeriodClick(prevPeriod, prevTypeGraph, statePeriod, nextPeriod) {
        sessionStorage.setItem("ResponseTimeSession",JSON.stringify({'nextPeriod':nextPeriod,'statePeriod':statePeriod}))
        const t = this.props.t;
        if (nextPeriod === 'hora' || nextPeriod === '3hora') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: 'h',
                typePeriod: 4,
                namePeriod: `${t('text.range')}: ${t('period.text.last-3-hours')}`,
                statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === 'dia') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: "d",
                typePeriod: 1,
                namePeriod: `${t('text.range')}: ${t('period.text.last-day')}`,
                statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === '3dia') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: "3d",
                typePeriod: 5,
                namePeriod: `${t('text.range')}: ${t('period.text.last-3-days')}`,
                statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === 'semana') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: "w",
                typePeriod: 2,
                namePeriod: `${t('text.range')}: ${t('period.text.last-week')}`,
                statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === 'custom') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: "c",
                typePeriod: 3,
                namePeriod: `${t('text.range')}: ${statePeriod.startDate.toISOString().substring(0, 10)} ${t('text.to2')} ${statePeriod.endDate.toISOString().substring(0, 10)}`,
                statePeriod: statePeriod,
                isStatePeriod: true,
                periodEl: null,
                isRefresh: false
            });
        }
    }

    /*handleNextStepClick(propsStep, nextStep) {
        const prevPeriod = propsStep.period
        const prevTypeGraph = propsStep.typeGraph
        const newStep = nextStep
        if (propsStep.step !== newStep) {
            this.setState({
                typeGraph: prevTypeGraph,
                period: prevPeriod,
                step: newStep,
                isLastEvent: false,
                extendEl: null,
            })
        }
    }*/
    handleNextStepClick = event => {
        const newSelectStep = event.currentTarget.name
        const newStep = event.currentTarget.id
        if (this.state.step !== newStep) {
            this.setState({
                //typeGraph: prevTypeGraph,
                //period: prevPeriod,
                step: newStep,
                isLastEvent: false,
                extendEl: null,
                nameSelectStep: newSelectStep,
                isRefresh: false
            })
        }
    }
    handleInfo(props, step) {
        let oldDate = new Date(props.x)
        let year = oldDate.getUTCFullYear()
        let month = oldDate.getUTCMonth()
        let day = oldDate.getUTCDate()
        let hours = oldDate.getUTCHours()
        let minutes = oldDate.getUTCMinutes()
        let seconds = oldDate.getUTCSeconds()

        let newDate = new Date(year, (month), day, hours, minutes, seconds)
        this.setState({
            nameStep: step,
            x: newDate.toLocaleString([], {hour12: false }),
            y: props.y
        })
    }


    handleFirstInfo(props) {
        let oldDate = new Date(props.x)
        let year = oldDate.getUTCFullYear()
        let month = oldDate.getUTCMonth()
        let day = oldDate.getUTCDate()
        let hours = oldDate.getUTCHours()
        let minutes = oldDate.getUTCMinutes()
        let seconds = oldDate.getUTCSeconds()
        let newDate = new Date(year, (month), day, hours, minutes, seconds)
        if (!this.state.isLastEvent && props.name !== null) {
            this.setState({
                nameStep: props.name,
                x: newDate.toLocaleString([], {hour12: false }),
                y: props.y,
                namePeriod: props.namePeriod,
                isLastEvent: true
            })
        }
    }
    handleDateMoment(props) {
        this.setState({
            dateMoment: props,
            isRefresh: false
        })
    }

    handleShowResponseTimeGraph = event => {
        this.setState({
            responseTimeGraphEl: event.currentTarget
        });
    };

    handleCloseResponseTimeGraph = () => {
        this.setState({
            responseTimeGraphEl: null
        });
    };

    handleShowPeriod = event => {
        this.setState({
            periodEl: event.currentTarget
        });
    };

    handleClosePeriod = () => {
        this.setState({
            periodEl: null
        });
    };

    handleShowExtend = event => {
        this.setState({
            extendEl: event.currentTarget
        });
    };

    handleCloseExtend = () => {
        this.setState({
            extendEl: null
        });
    };

    handleRefresh = event => {
        this.setState({
            isRefresh: true,
            settingsEl: null,
        })
    }

    handleShowSettings = event => {
        this.setState({
            settingsEl: event.currentTarget
        });
    };
    handleShowIsInfo = event => {
        this.setState({
            isInfo: event.currentTarget
        });
    };
    handleCloseSettings = () => {
        this.setState({
            settingsEl: null
        });
    };
    handleCloseIsInfo = () => {
        this.setState({
            isInfo: null
        });
    };
    handleChange = name=>event => {
        if (event.target.checked) {
            clearInterval(this.state.intervalId)
            const newIntervalId = setInterval(
                () => this.tick(),
                this.props.refreshTime || REFRESH_TIME
            );
            this.setState({intervalId: newIntervalId})
        }
        this.setState({ 
            checkedA: event.target.checked 
        });
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.automaticUpdate !== this.props.automaticUpdate && prevProps.refreshTime === this.props.refreshTime) {
            if (this.props.automaticUpdate) {
                clearInterval(this.state.intervalId)
                const newIntervalId = setInterval(
                    () => this.tick(),
                    this.props.refreshTime || REFRESH_TIME
                );
                this.setState({
                    intervalId: newIntervalId,
                    checkedA: this.props.automaticUpdate
                })
            } else {
                this.setState({checkedA: this.props.automaticUpdate})
                clearInterval(this.state.intervalId)
            }
        }
        if (prevProps.refreshTime !== this.props.refreshTime && this.state.checkedA) {
            clearInterval(this.state.intervalId)
            const newIntervalId = setInterval(
                () => this.tick(),
                this.props.refreshTime || REFRESH_TIME
            );
            this.setState({
                intervalId: newIntervalId,
            })
        }

        if (prevProps.match.params.objetivo_id !== this.props.match.params.objetivo_id) {
            this.setState({
                typeGraph: 0,
                period: this.state.period,
                step: this.state.step,
                isForStep: false,
                nameStep: null,
                x: null,
                y: null,
                isLastEvent: false,
                objetive: this.props.match.params.objetivo_id,
                periodEl: null
            })
        }
        if (this.props.globalPeriodValue) {
            if (prevProps.globalPeriodValue !== this.props.globalPeriodValue ||
                (this.props.globalPeriodValue === "custom" &&
                this.props.globalStatePeriod.startDate !== prevProps.globalStatePeriod.startDate)
            ) {
                this.handlePeriodClick(null, this.state.typeGraph, this.props.globalStatePeriod, this.props.globalPeriodValue)
            }
        }
    }

    render() {

        const divStyle = {
            top: '32%',left: '63%', width:'500px'
          };
        const { classes, className, location, ...rest } = this.props;

        const { typeGraph, period, isForStep, step, x, y, nameStep, statePeriod, isStatePeriod, namePeriod, responseTimeGraphEl, 
            periodEl, nameGraph, typePeriod, extendEl, nameSelectStep, settingsEl, isRefresh,isInfo, detalleGraph, 
            date, dateMoment, isOneHour, schedule, scheduleName, periodical} = this.state;
        let buttonResponse;
        let buttonStep;
        let buttonNode;
        const showResponseTimeGraphEl = Boolean(responseTimeGraphEl);
        const showPeriodEl = Boolean(periodEl);
        const showIsInfo = Boolean(isInfo);
        const showExtendEl = Boolean(extendEl);
        const showSettingsEl = Boolean(settingsEl);

        buttonResponse = <ResponseButton onClick={this.handleResponseClick} />;
        buttonStep = <StepButton onClick={this.handleStepClick} />;
        buttonNode = <NodeButton onClick={this.handleNodeClick} />;

        const rootClassName = classNames(classes.root, className);
        const t = (this.props && this.props.t) ? this.props.t : (s => s)
        const namePeriodPortlet = [t('period.text.last-hour'), t('period.text.last-day'), t('period.text.last-week'), t('period.text.custom'), t('period.text.last-3-hours'), t('period.text.last-3-days')]
        if (!this.state.dataError) {
            return (
                <Portlet
                    /*  {...rest} */
                    className={rootClassName}
                >
                    <PortletHeader className={classes.header}
                    >
                        <PortletLabel
                            /*  icon={<DevicesIcon />} */
                            variant="h6"
                            title={this.props.title + t(`response-time.name-graph.${typeGraph}`)}
                            
                        />

                        <PortletToolbar>
                            <IconButton
                                //className={classes.refreshButton}
                                //variant="text"
                                onClick={this.handleShowSettings}
                            >
                                <SettingsOutlinedIcon />
                                
                            </IconButton>
                            <Popover
                                anchorEl={settingsEl}
                                
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'center',
                                }}
                                onClose={this.handleCloseSettings}
                                open={showSettingsEl}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'center',
                                }}>
                                <IconButton
                                    className={classes.refreshButton}
                                    variant="text"
                                    onClick={this.handleRefresh}
                                    onClose={this.handleCloseSettings}
                                >
                                    <div>
                                    <RefreshIcon color="infoIcon" /><Typography variant="h4" style={{fontSize:'15px',float:'right', paddingLeft:'5px', color:'#66788A'}}>{t('text.update')}</Typography>
                                    </div>
                                </IconButton>
                                <IconButton
                                        onClick={this.handleShowIsInfo}
                                        onClose={this.handleCloseIsInfo}
                                    >
                                        <div>
                                            <HelpIcon color="infoIcon"/><Typography variant="h4" style={{fontSize:'15px',float:'right', paddingLeft:'5px', color:'#66788A'}}>{t('response-time.tooltip.information')}</Typography>
                                        </div>
                                    </IconButton>
                                     <Popover
                                        anchorEl={isInfo}
                                        open={showIsInfo}
                                        onClose={this.handleCloseIsInfo}
                                        >
                                        <PortletContent variant="h4" style={{fontSize:'16px', color:'#66788A'}}>{t(`response-time.details-graph.${typeGraph}`)}</PortletContent>
                                    </Popover>
                                    <Tooltip title={t('text.auto-update')}>
                                        <div style={{textAlign:"center"}}>
                                            <Switch
                                                checked={this.state.checkedA}
                                                onChange={this.handleChange('checkedA')}
                                                value="checkedA"
                                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                                                color='primary'
                                            />
                                        </div>
                                    </Tooltip>

                            </Popover>
                            <Button
                                style={{color:"#353535"}}
                                variant="text"
                                onClick={this.handleShowResponseTimeGraph}
                            >
                                {t('response-time.graphs.text')} <ArrowRightIcon />
                            </Button>
                            <Popover
                                anchorEl={responseTimeGraphEl}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'center'
                                }}
                                onClose={this.handleCloseResponseTimeGraph}
                                open={showResponseTimeGraphEl}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'center'
                                }}>
                                <div style={{textAlign:"left"}}>
                                    {buttonResponse}<br />
                                    {buttonStep}<br />
                                    {buttonNode}
                                </div>
                            </Popover>
                        </PortletToolbar>
                    </PortletHeader>
                    <PortletContent className={classes.content}>
                        <Grid
                            container
                            spacing={10}
                        >
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                xl={12}
                                >
                                <PerfectScrollbar>
                                    <div >
                                    {period == 'c' ?
                                             <div >
                                             <Typography   color="textSecondary" gutterBottom>
                                                 {t('text.from')} {statePeriod.startDate.toISOString().substring(0, 10)} {t('text.to')} {moment(statePeriod.endDate).format().substring(0, 10)}
                                             </Typography>
                                             {periodical?
                                             <Typography   color="textSecondary" gutterBottom>
                                                 {t('response-time.schedule.text')} {scheduleName}
                                             </Typography>
                                             :null
                                             }
                                         </div>
                                         
                                     : null}
                                        {<Graph
                                            typeGraph={typeGraph}
                                            period={period}
                                            step={step}
                                            onInfo={this.handleInfo}
                                            onFirstInfo={this.handleFirstInfo}
                                            statePeriod={statePeriod}
                                            isStatePeriod={isStatePeriod}
                                            isRefresh={isRefresh}
                                            date={date}
                                            onDateMoment={this.handleDateMoment}
                                            schedule={schedule}
                                            scheduleName={scheduleName}/>}                            
                                    </div>
                                    <div>
                                    <div>
                                        <Typography variant="h4" style={{fontSize:'13px',float:'left', paddingLeft:'5px', color:'#66788A'}}>
                                            {/*<h5>{namePeriod}</h5>*/}
                                            <h5>{nameStep}</h5>
                                            <h1>{y}(s)</h1>
                                            <h5>{x}</h5>
                                        </Typography>
                                    </div>
                                    <div style={{float:"right", marginTop:"5%"}}>
                                        <div style={{
                                                        display: 'flex',
                                                        alignItems: 'center'
                                                    }}>
                                                {/* <Typography >
                                               Última actualización:
                                               </Typography> */}
                                                
                                            <Avatar variant="rounded" className={classes.rounded}>
                                            <UpdateIcon /> 
                                            </Avatar>
                                            <Typography  className={classes.updateTime}   >
                                                    &nbsp; {t('text.last-update')}: {dateMoment} 
                                            </Typography>
                                            
                                        </div>
                                    </div>
                                </div>
                                </PerfectScrollbar>
                            </Grid>
                            
                        </Grid>     
                        
                    </PortletContent>
                    <PortletFooter className={classes.portletFooter}>
                        <Button variant="h4" style={{fontSize:'15px',float:'left', color:'#66788A'}} onClick={this.handleShowPeriod}>
                            {namePeriodPortlet[typePeriod]}<ArrowDropDownIcon />
                        </Button>
                        <Popover
                            anchorEl={periodEl}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center'
                            }}
                            onClose={this.handleClosePeriod}
                            open={showPeriodEl}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center'
                            }}>
                            <Period onClick={this.handlePeriodClick} period={period} typeGraph={typeGraph} isOneHour={isOneHour}/>
                        </Popover>

                        {typeGraph !== 0 ?
                            <Button
                                variant="text"
                                onClick={this.handleShowExtend}
                            >
                                {nameSelectStep}
                                <ArrowRightIcon />
                            </Button>
                        : null
                        }
                        
                        {<Popover
                            anchorEl={extendEl}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center'
                            }}
                            onClose={this.handleCloseExtend}
                            open={showExtendEl}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center'
                            }}>
                            <div >
                                {isForStep ? <div className="row1">
                                                <List component="div">
                                                    {Object.values(location.state.fromObjective.Pasos).map(i => (
                                                
                                                        <ListItem
                                                            className={classes.listItem}
                                                            component="div"
                                                        >
                                                           <Button id={i.id_paso} name={i.nombre_paso} onClick={(event) => this.handleNextStepClick(event)}>{i.nombre_paso}</Button> 
                                                        </ListItem>))}
                                                </List>
                                                </div> : <div style={{paddingLeft:'5px',paddingRight:'5px',paddingTop:'5px', fontFamily:'Roboto'}}>{t('response-time.no-more-information')}</div>}
                            </div>

                        </Popover>}
                        
                    </PortletFooter>
                </Portlet>


            )
        }
        else if (this.state.dataError) {
            return (<p>{t('text.no-data')}</p>)
        }
        else if (this.state.isLoading) {
            return (<p>{t('text.loading')}</p>)
        }
        else if (this.state.externalData == null) {
            return (<p>{t('text.loading')}</p>)
        }
        else return (<p>{t('response-time.error')}</p>)
    }
}

function Graph(props) {
    const typeGraph = props.typeGraph;
    if (typeGraph === 0) {
        return <ResponseTimeGeneral params={props} />;
    }
    if (typeGraph === 1) {
        return <ResponseTimeForStep params={props} />;
    }
    if (typeGraph === 2) {
        return <ResponseTimeForNode params={props} />;
    }
}

function ResponseButton(props) {
    const { t } = useTranslation();
    return (
        <Button variant="text" onClick={props.onClick}>
            {t('response-time.button.consolidated')}
      </Button>
    );
}

function StepButton(props) {
    const { t } = useTranslation();
    const tab = <>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>;
    return (
        <Button variant="text" onClick={props.onClick}>
            {t('response-time.button.step')}{tab}
      </Button>
    );
}

function NodeButton(props) {
    const { t } = useTranslation();
    const tab = <>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>;
    return (
        <Button variant="text" onClick={props.onClick}>
            {t('response-time.button.isp')}{tab}
      </Button>
    );
}

export default
    compose(withRouter, withStyles(styles), withTranslation())(ResponseTime);